import { Observable } from "knockout";
import { useEffect, useState } from "react";

export const useKnockoutObservable = <T>(observable: Observable<T> | F<T>): [T] => {
    const [state, setState] = useState<T>(observable());

    const [computed] = useState(() =>
        ko.computed(() => {
            const newState = observable();

            if (!ko.computedContext.isInitial()) {
                setState(newState);
            }
        })
    );

    useEffect(() => {
        return () => {
            computed.dispose();
        };
    }, []);

    return [state];
};
